import "./assets/main.css";

import { createAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";
import { createPinia } from "pinia";
import { createApp, provide } from "vue";
import { Vue3Mq } from "vue3-mq";

import App from "./App.vue";
import router from "./router";
import { startVersionCheck } from "./versionCheck";

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(Vue3Mq, {
  preset: 'tailwind'
});

axios
  .get('/config.json')
  .then(response => {

    app.use(
      createAuth0({
        domain: response.data.AOL_AUTH0_DOMAIN,
        client_id: response.data.AOL_AUTH0_CLIENT_ID,
        audience: response.data.AOL_AUTH0_AUDIENCE,
        redirect_uri: response.data.AOL_AUTH0_REDIRECT,
      })
    );

    try {
      if (response.data.AOL_SENTRY_DISABLED !== 'disabled') {
        Sentry.init({
          app,
          dsn: response.data.AOL_SENTRY_DSN,
          integrations: [
            Sentry.browserTracingIntegration({ router }),
          ],
          environment: response.data.AOL_SENTRY_ENV,
          tracePropagationTargets: [window.location.host],
          tracesSampleRate: 1.0,
        });
        Sentry.getGlobalScope().setAttributes({ application: "asteonline-admin-ui" });

        window.addEventListener('keydown', (e) => {
          if (e.ctrlKey && e.shiftKey && e.key === 'S') {
            Sentry.captureException(new Error(`[TEST] Sentry test error triggered manually - ${new Date().toISOString()}`));
            console.log('✅ Test error sent to Sentry!');
          }
        });
      }
    } catch(error) {
      console.log(e);
      window.alert('Sentry error! Open console to see the error!');
    }

    app.provide('config', response.data);

  })
  .catch((e) => {
    console.log(e);
    window.alert('/config.json does not exists. Please create it and reload!')
  })
  .finally(() => {
    app.mount("#app");
    startVersionCheck(__APP_VERSION__);
  });